export const LINKS = {
    FOOTER_AOS: 'https://link.banksalad.com/0zftoi?utm_content=footer_android',
    FOOTER_IOS: 'https://link.banksalad.com/0zftoi?utm_content=footer_ios',
    FOOTER_MAIL_INFO: 'mailto:hello@banksalad.com',
    FOOTER_NOTICE: 'https://banksalad.com/notice',
    FOOTER_AUTH_WORK_RULE: 'https://policies.banksalad.com/banksaladcertificate/cps',
    FOOTER_MYDATA_CERTIFICATE_TERMS: 'https://policies.banksalad.com/banksaladcertificate/뱅크샐러드-인증서-이용약관',
    FOOTER_MYDATA_CERTIFICATE_PRIVACY_POLICY: 'https://policies.banksalad.com/banksaladcertificate/뱅크샐러드-인증서-개인정보처리방침',
    FOOTER_ACCREDITATION: 'https://rootca.or.kr/accreditation/accredited-providers',
};
